import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {useAppDispatch} from '../store/hooks.ts'
import {logout} from '../store/slices/authSlice.ts'
import './Layout.css'
import {useCallback, useEffect, useState} from 'react'
import UserIcon from '@/assets/icons/UserIcon'
import BookIcon from '@/assets/icons/BookIcon'
import {RootNavPanel, SideNav} from '@fs/uikit-react'

const OperatorLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const [arePanelsVisible, setArePanelsVisible] = useState<boolean>(true);

  // Navigate to the first page when entering OperatorLayout
  useEffect(() => {
    if (location.pathname === '/operator') {
      navigate('/operator/person');
    }
  }, [location.pathname, navigate]);

  // Function to toggle visibility of all panels
  const handleToggleAllPanels = useCallback(() => {
    setArePanelsVisible(prevState => !prevState);
  }, []);

  // Add a keyboard shortcut (Alt+F) to toggle all panels
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.altKey && (event.code === 'KeyF')) {
        handleToggleAllPanels();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleToggleAllPanels]);

  const handleLogout = () => {
    dispatch(logout())
    navigate('/')
  }

  const menuItems = [
    {
      id: 'person',
      label: 'Особи',
      icon: <UserIcon/>,
      onClick: () => { navigate('/operator/person'); },
      active: window.location.pathname.startsWith('/operator/person')
    },
    {
      id: 'categories',
      label: 'Категорії',
      icon: <BookIcon/>,
      onClick: () => { navigate('/operator/categories'); },
      active: window.location.pathname.startsWith('/operator/categories')
    },
    {
      id: 'directories',
      label: 'Довідники',
      icon: <BookIcon/>,
      subItems: [
        {
          id: 'institutions',
          label: 'Установи',
          onClick: () => { navigate('/operator/institutions'); },
          active: window.location.pathname.startsWith('/operator/institutions')
        },
        {
          id: 'settlements',
          label: 'Населені пункти',
          onClick: () => { navigate('/operator/settlements'); },
          active: window.location.pathname.startsWith('/operator/settlements')
        },
        {
          id: 'contact-link-categories',
          label: 'Категорії посилань',
          onClick: () => { navigate('/operator/contact-link-categories'); },
          active: window.location.pathname.startsWith('/operator/contact-link-categories')
        }
      ]
    }
  ]

  return (
    <div className="layout operator-theme">
      <header className="header">
        <RootNavPanel
          labelText="Оператор"
          logoImage={'/logo.svg'}
          className={!arePanelsVisible ? 'fs-root-nav-panel--hidden' : ''}
        />
      </header>
      <div className="content-container">
        <SideNav
          menuItems={menuItems}
          className="operator-sidenav"
          collapsed={!arePanelsVisible}
        />
        <main className="main">
          <Outlet/>
        </main>
      </div>
    </div>
  )
}

export default OperatorLayout
